import React from 'react'

function Devices() {
  return (
    <div>section is under construction</div>
  )
}

export default Devices